<template>
  <div class="getCode">
    <div id="printTest" class="getCode-body">
      <p class="getCode-title">{{ title ? title : "扫码领电子会员卡" }}</p>
      <!-- <img :src="src" class=" unselectable" /> -->
      <!-- <div class="qrcode" id="qrcode" ref="qrCodeUrl"></div> -->
      <canvas width="500" height="500" id="canvas" ref="myCanvas"></canvas>
    </div>
    <div class="getCode-bottom">
      <el-input
        v-model="title"
        placeholder="请输入标题文字"
        style="width: 300px"
      >
      </el-input>
      <el-button v-print="'#printTest'" type="success" style="margin-left: 20px"
        >打印领卡二维码</el-button
      >
      <el-button @click="downLoad" type="primary"
        >下载领卡二维码到本地</el-button
      >
      <el-button @click="getCode" type="danger">重新获取二维码</el-button>
    </div>
  </div>
</template>
<script>
// import QRcode from "qrcode";
var QRcode = require("qrcode");
// import { wxbaseurl } from "@/api/common.js";
import { getAttention, getMiniQrcode } from "@/api/wxService";
import { downloadIamge } from "@/js/public.js";
export default {
  name: "getCode",
  data() {
    return {
      src: "",
      title: "扫码领电子会员卡",
    };
  },
  async mounted() {
    this.getCode();
    // this.creatQrCode("123");

    // console.log("111111111111", QRcode);
  },
  methods: {
    //下载二维码
    downLoad() {
      // downloadIamge(this.src, "领卡二维码");
      let myCanvas = this.$refs.myCanvas;
      // 生成图片（图片的格式）
      let imageUrl = myCanvas.toDataURL("image/png", 0.5);

      // this.downloadFile();
      downloadIamge(imageUrl, "会员注册码.png");
    },
    //获取二维码扫码跳转地址
    getCode() {
      const url = getMiniQrcode();
      console.log(url);
      this.creatQrCode(url);
      /* const token_type = localStorage.getItem("token_type");
      const res = await getAttention(token_type); //获取跳转链接
      if (this.testR(res)) {
        this.creatQrCode(res.data.resp_data.url);
      } */
    },
    //生成二维码
    creatQrCode(src) {
      var canvas = document.getElementById("canvas");
      QRcode.toCanvas(
        canvas,
        src,
        {
          scale: 10,
          height: 300,
          wight: 300,
        },
        function (error) {
          if (error) console.error(error);
        }
      );
    },
  },
};
</script>
<style lang="less" scoped>
#canvas {
  width: 300px !important;
  height: 300px !important;
}

.getCode-body {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // height: auto;
  .getCode-title {
    color: rgb(253, 0, 0);
    font-size: 60px;
    font-weight: 700;
    margin: 0;
    margin-bottom: 20px;
  }
}
.getCode-bottom {
  width: 100%;
  display: flex;
  justify-content: center;
}
.unselectable {
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
  user-select: none;
}
</style>
